// extracted by mini-css-extract-plugin
export default {"container":"xNXiKzC6qvOfgf59NWQ7","logo":"PDt2MiXGbiAGaYVsd9WY","divider":"AfUpPZ33ENuCtJdLcHNe"};